// extracted by mini-css-extract-plugin
module.exports = {"button":"v_button_button__1g29y"};